module.exports = __webpack_public_path__ + "static/media/wissam.40585d67.png";